import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
    REPORTS_BASE_URL,
    RECENT_ACTIVITY,
} from "../../../../Constants/Config";
import { useAuthDetails } from "../../../../Common/cookiesHelper";

const initialState = {
    isLoading: false,
    activityData: [],
    error: null,
};

export const getRecentActivity = createAsyncThunk(
    "recentActivity/getRecentActivity",
    async (payload, { rejectWithValue }) => {
        const { userTypeData } = useAuthDetails();
        try {
            const { token, ...otherUserData } = userTypeData;

            const apiUrl = REPORTS_BASE_URL + RECENT_ACTIVITY;

            const response = await axios.post(apiUrl, { ...payload, ...otherUserData }, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response?.data?.status === true || response?.data?.status === 200) {
                return response?.data?.data || [];
            }

            if (Array.isArray(response?.data?.data)) {
                return response.data.data;
            }
            if (Array.isArray(response?.data)) {
                return response.data;
            }

            return rejectWithValue(response?.data?.message || "Failed to fetch activity");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.detail || "Failed to fetch activity"
            );
        }
    }
);

const recentActivitySlice = createSlice({
    name: "recentActivity",
    initialState,
    reducers: {
        clearActivity: (state) => {
            state.activityData = [];
            state.isLoading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getRecentActivity.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getRecentActivity.fulfilled, (state, action) => {
                state.isLoading = false;
                state.activityData = action.payload;
                state.error = null;
            })
            .addCase(getRecentActivity.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    },
});

export const { clearActivity } = recentActivitySlice.actions;
export default recentActivitySlice.reducer;
